import React from 'react'
import Navbar from '../../Components/Navbar/Navbar'
import Footer from '../../Components/Footer/Footer'
import ViewBookComponent from '../../Components/ViewBookComponent/ViewBookComponent'
import "./ViewBook.css"
import RelatedViewBook from '../../Components/RelatedViewBook/RelatedViewBook'
import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
export default function ViewBook(props) {
    const bookId = useParams().id;
    const { books } = useSelector(state => state.Books);
    const book = books.find(book => book._id === bookId);
  return (
      <div className='ViewBook'>
          <Navbar colorLeft="#5f2c3e" colorRight="#5f2c3e" />
          <ViewBookComponent book = {book} />
          <RelatedViewBook book = {book}/>
          <Footer/>
    </div>
  )
}
